module.exports = __webpack_public_path__ + "static/media/logoMin_.75cca8ed.png";